// Determine the API base URL based on the environment
export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : `http://localhost:8000/api`;

// Define the endpoints
export const LOGIN_ENDPOINT = `${API_BASE_URL}/auth/email/`;
export const REFRESH_TOKEN_ENDPOINT = `${API_BASE_URL}/auth/refresh/`;
export const OTP_VERIFICATION_ENDPOINT = `${API_BASE_URL}/auth/email/verify-otp/`;

export const CUSTOMERS_ENDPOINT = `${API_BASE_URL}/customers/`;
export const CUSTOMERS_SEARCH_ENDPOINT = `${API_BASE_URL}/customers/search/`;
export const CUSTOMERS_CREATE_ENDPOINT = `${API_BASE_URL}/customers/add/`;
export const CUSTOMERS_EDIT_ENDPOINT = `${API_BASE_URL}/customers/edit/`;

export const VANS_ENDPOINT = `${API_BASE_URL}/drivers/vans/`;
export const VANS_EDIT_ENDPOINT = `${API_BASE_URL}/drivers/vans/edit/`;
export const VANS_CREATE_ENDPOINT = `${API_BASE_URL}/drivers/vans/add/`;

export const DRIVERS_ENDPOINT = `${API_BASE_URL}/drivers/`;
export const DRIVERS_SEARCH_ENDPOINT = `${API_BASE_URL}/drivers/search/`;
export const DRIVERS_CREATE_ENDPOINT = `${API_BASE_URL}/drivers/add/`;
export const DRIVERS_EDIT_ENDPOINT = `${API_BASE_URL}/drivers/edit/`;

export const USERS_ENDPOINT = `${API_BASE_URL}/users/`;
export const USERS_CREATE_ENDPOINT = `${API_BASE_URL}/users/`;
export const USERS_EDIT_ENDPOINT = `${API_BASE_URL}/users/`;

export const CHAT_CLIENT_HISTORY_ENDPOINT = `${API_BASE_URL}/chat/topics/clients/history/`;
export const CHAT_HISTORY_ENDPOINT = `${API_BASE_URL}/chat/topics/history/`;

export const ZONES_ENDPOINT = `${API_BASE_URL}/zones/`;
export const ZONE_CREATE_ENDPOINT = `${API_BASE_URL}/zones/add/`;
export const ZONE_EDIT_ENDPOINT = `${API_BASE_URL}/zones/edit/`;
export const SUBZONES_ENDPOINT = `${API_BASE_URL}/zones/sub-zones/`;
export const SUBZONE_EDIT_ENDPOINT = `${API_BASE_URL}/zones/sub-zones/edit/`;
export const SUBZONE_CREATE_ENDPOINT = `${API_BASE_URL}/zones/sub-zones/add/`;
export const ORDERS_ENDPOINT = `${API_BASE_URL}/orders/`;
export const ORDERS_STATUS_EDIT_ENDPOINT = `${API_BASE_URL}/orders/edit-status/`;

export const DRIVER_ORDER_REPORTS_URL = `${API_BASE_URL}/reports/drivers/`;
export const CUSTOMER_ORDER_REPORTS_URL = `${API_BASE_URL}/reports/customers/`;
export const ZONE_ORDER_REPORTS_URL = `${API_BASE_URL}/reports/zones/`;

export const MONTHLY_PERFORMANCE_REPORTS_URL = `${API_BASE_URL}/reports/orders-monthly-aggregate/`;
export const TIMESLOT_REPORTS_URL = `${API_BASE_URL}/reports/orders-timeslot-aggregate/`;

export const JOBS_ENDPOINT = `${API_BASE_URL}/jobs/`;
export const JOB_EXECUTE_ENDPOINT = `${API_BASE_URL}/jobs/execute-job/`;
export const JOBS_LOG_ENDPOINT = `${API_BASE_URL}/jobs/logs/`;

export const TEMPLATE_ENDPOINT = `${API_BASE_URL}/templates/`;
export const TEMPLATE_CREATE_ENDPOINT = `${API_BASE_URL}/templates/create/`;
export const TEMPLATE_EDIT_ENDPOINT = `${API_BASE_URL}/templates/edit/`;
export const TEMPLATE_DELETE_ENDPOINT = `${API_BASE_URL}/templates/delete/`;

export const TEMPLATE_BROADCAST_ENDPOINT = `${API_BASE_URL}/templates/broadcast/`;

export const AUDIENCE_GET_ENDPOINT = `${API_BASE_URL}/audience/`;
export const AUDIENCE_UPDATE_ENDPOINT = `${API_BASE_URL}/audience/add-segment/`;
export const AUDIENCE_DELETE_ENDPOINT = `${API_BASE_URL}/audience/delete-audience/`;
export const AUDIENCE_FILE_UPLOAD_ENDPOINT = `${API_BASE_URL}/audience/upload-audience/`;
export const AUDIENCE_EXPORT_ENDPOINT = `${API_BASE_URL}/audience/export`;

export const SEGMENT_AUDIENCE_ENDPOINT = `${API_BASE_URL}/audience/segment-audience/`;

export const SEGMENT_LIST_ENDPOINT = `${API_BASE_URL}/audience/segments/`;
export const SEGMENT_CREATE_ENDPOINT = `${API_BASE_URL}/audience/segments/create/`;
export const SEGMENT_EDIT_ENDPOINT = `${API_BASE_URL}/audience/segments/update/`;
export const FILE_UPLOAD_AUDIENCE_ENDPOINT = `${API_BASE_URL}/audience/upload-audience/`;

export const CAMPAIGN_LIST_ENDPOINT = `${API_BASE_URL}/campaign/`;

export const WHATSAPP_BILLING_LIST_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/`;
export const WHATSAPP_BILLING_LIST_EXPORT_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/export/`;
export const WHATSAPP_BILLING_CREATE_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/create/`;

export const WHATSAPP_META_CARD_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/meta-rate-card/`;

export const WHATSAPP_MESSAGE_LOG_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/messages/`;
export const WHATSAPP_MESSAGE_LOG_EXPORT_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/messages/export`;
export const WHATSAPP_MARKETING_LOG_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/marketing/`;
export const WHATSAPP_MARKETING_LOG_EXPORT_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/marketing/export`;

export const WHATSAPP_BROADCAST_LOG_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/broadcast-campaigns/`;
export const WHATSAPP_SCHEDULED_BROADCAST_LOG_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/broadcast/scheduled/`;
export const REPORT_EXPORT_URL = `${API_BASE_URL}/reports/export-csv/`;

export const GENERATE_QR_ENDPOINT = `${API_BASE_URL}/url-qrcode/`;
export const GENERATE_QR_GET_NUMBER_ENDPOINT = `${API_BASE_URL}/url-qrcode/get-num-qr`;

export const SETTINGS_DASHBOARD_ENDPOINT = `${API_BASE_URL}/settings-dashboard/`;

export const CHAT_START_TOPIC_ENDPOINT = `${API_BASE_URL}/chat/topics/start/`;
export const CHAT_END_TOPIC_ENDPOINT = `${API_BASE_URL}/chat/topics/end/`;

export const PRODUCTS_GET_ENDPOINT = `${API_BASE_URL}/product/`;
export const PRODUCTS_CREATE_ENDPOINT = `${API_BASE_URL}/product/create/`;
export const PRODUCTS_UPDATE_ENDPOINT = `${API_BASE_URL}/product/update/`;

export const ORDER_ITEM_GET_ENDPOINT = `${API_BASE_URL}/orderitem/`;
export const DAILY_HOLDING_ENDPOINT = `${API_BASE_URL}/investments/holdings/daily/`; 
export const MONTHLY_HOLDING_ENDPOINT = `${API_BASE_URL}/investments/holdings/monthly/`; 
export const CAREPMS_CUSTOMERS_LIST_ENDPOINT = `${API_BASE_URL}/clients/clients/`;
export const CAREPMS_UPLOAD_HISTORY_ENDPOINT = `${API_BASE_URL}/history/upload-history/`;

export const FILE_UPLOAD_HISTORY_ENDPOINT = `${API_BASE_URL}/logs/file-upload-history/`;

export const USER_ENGAGEMENT_ENDPOINT = `${API_BASE_URL}/user-engagement/`;
export const USER_ENGAGEMENT_EXPORT_ENDPOINT = `${API_BASE_URL}/user-engagement/export`;

export const LIST_TEMPLATES_ANALYTICS_ENDPOINT = `${API_BASE_URL}/template-analytics`;
export const TEMPLATE_ANALYTICS_EXPORT_ENDPOINT = `${API_BASE_URL}/template-analytics/export`;

export const GENAI_ENHANCE_TEXT_ENDPOINT = `${API_BASE_URL}/enhance-text/`;


export const APPOINTMENTS_ENDPOINT = `${API_BASE_URL}/appointment-management`;

// export const ORDER_ITEM_GET_ENDPOINT = `${API_BASE_URL}/orderitem/`;
// export const ORDER_ITEM_GET_ENDPOINT = `${API_BASE_URL}/orderitem/`;

export const GET_INVOICES_ENDPOINT = `${API_BASE_URL}/invoices/invoices/`;


export const GET_WALLET_ENDPOINT = `${API_BASE_URL}/wallet`;

export const GET_WALLET_DETAILS = `${API_BASE_URL}/wallet/wallet/`;
export const GET_WALLET_STATS = `${API_BASE_URL}/wallet/wallet/stats`;
export const GET_WALLET_SUMMARY = `${API_BASE_URL}/wallet/wallet/summary`;

export const GET_WALLET_TRANSACTIONS = `${API_BASE_URL}/wallet/transactions/`;
export const GET_WALLET_SINGLE_TRANSACTIONS_ = `${API_BASE_URL}/wallet/transactions/<int:pk>/`;

export const GET_WALLET_ADD_FUNDS = `${API_BASE_URL}/wallet/add-funds/`;
export const GET_WALLET_INITIATE_CASHFREE_ENDPOINT = `${API_BASE_URL}/wallet/initiate-cashfree/`;
export const GET_WALLET_VERIFY_CASHFREE_ENDPOINT = `${API_BASE_URL}/wallet/verify-funds/`;

// export const CALENDLY_STANDALONE_DHRUV = `https://calendly.com/shahdhruv101005/30min`;
export const CALENDLY_ENDPOINT = `${API_BASE_URL}/calendly/`;

export const CONVERSATIONS_ENDPOINT = `${API_BASE_URL}/conversations/`;
export const SEND_MESSAGE_ENDPOINT = (conversationId) => `${API_BASE_URL}/conversations/${conversationId}/send-message/`;
export const MESSAGES_ENDPOINT = (conversationId) => `${API_BASE_URL}/conversations/${conversationId}/messages/`;

export const ZOHO_CALLBACK_ENDPOINT = `${API_BASE_URL}/zoho/callback/`;
export const ZOHO_GET_CREDENTIALS_ENDPOINT = `${API_BASE_URL}/zoho/credentials/`;
export const ZOHO_SYNC_LEADS_ENDPOINT = `${API_BASE_URL}/zoho/sync-leads/`;



